import { render, staticRenderFns } from "./Vendors.vue?vue&type=template&id=64162fe8&scoped=true"
import script from "./Vendors.vue?vue&type=script&lang=js"
export * from "./Vendors.vue?vue&type=script&lang=js"
import style0 from "./Vendors.vue?vue&type=style&index=0&id=64162fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64162fe8",
  null
  
)

export default component.exports